import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import { Glass, GlassExtended } from '@sc/data-access-models';
import { CarImgService } from '../../services';
import { NgIf } from '@angular/common';

@Component({
  selector: 'sc-car-miniature-img',
  styleUrls: ['./car-miniature-img.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CarImgService],
  template: `
    <span *ngIf="isTopPerspective()">
      <svg
        aria-hidden="true"
        focusable="false"
        viewBox="0 0 311 145"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Maquette"
          stroke="none"
          stroke-width="2"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="aari-5" transform="translate(-32.000000, -526.000000)">
            <g
              id="Schéma_car_top"
              transform="translate(187.500000, 598.500000) rotate(-270.000000) translate(-187.500000, -598.500000) translate(115.000000, 443.000000)"
            >
              <!-- Car body -->
              <path
                d="M72.7406877,0.628373159 L73.4828013,0.630327799 C93.7600922,0.737634919 108.245605,5.25095416 116.882234,14.273133 C125.450488,23.2238855 130.912607,33.1822898 133.258527,44.1494681 L133.258527,44.1494681 L133.386582,44.7659339 L133.386656,162.006491 L132.020229,251.260337 L123.25458,293.154356 C121.168437,298.451048 117.83981,302.549955 113.671515,305.439364 C109.492983,308.33587 104.472536,310.01778 99.1753664,310.099988 L99.1753664,310.099988 L46.7338872,310.103232 C41.347702,310.103232 36.2403765,308.454208 31.9880164,305.555419 C27.7443398,302.662549 24.3521214,298.525025 22.3839873,293.539641 L22.3839873,293.539641 L13.4704695,251.259855 L12.104124,162.016109 L12.104124,44.7642289 C14.3767521,33.5518823 19.8813978,23.3897953 28.6084723,14.273133 C37.2451009,5.25095416 51.7306137,0.737634919 72.0062498,0.630334378 L72.0062498,0.630334378 L72.7406877,0.628373159 Z"
                id="corps"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="var(--color-grey-extra-light)"
              ></path>

              <!-- Top window -->
              <rect
                *ngIf="'topWindow' as id"
                [id]="id"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                x="43.1039743"
                y="138.766222"
                width="59.38147"
                height="86.7157974"
                rx="3.35133517"
                [class.selectedGlass]="isSelected(id)"
              ></rect>

              <!-- Rear window -->
              <path
                *ngIf="'rearWindow' as id"
                [id]="id"
                d="M112.970387,236.350223 C113.05533,236.332527 113.139408,236.350933 113.206675,236.394998 L113.206675,236.394998 L116.347075,275.425529 C106.572653,280.805909 92.1806306,283.083092 72.7423447,283.083092 C53.3163766,283.083092 38.9297741,280.806507 29.5933604,276.219015 L29.5933604,276.219015 L32.1369337,236.633572 C32.1436124,236.547075 32.1847221,236.471478 32.2457857,236.419176 C32.3003185,236.372469 32.3707636,236.344339 32.4492198,236.343668 C45.6179378,239.078509 59.0135281,240.438485 72.7423447,240.438485 C86.4856303,240.438485 99.8949859,239.075621 112.970387,236.350223 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Windshield -->
              <path
                *ngIf="'windshield' as id"
                [id]="id"
                d="M72.2710632,70.2733093 C94.5149791,70.2733093 111.417759,76.0317548 122.952899,87.6025369 L122.952899,87.6025369 L114.93326,127.601565 C100.426188,123.60729 86.3485749,121.496329 72.2710632,121.496329 C58.1904633,121.496329 44.1097704,123.608241 30.0290603,127.833057 L30.0290603,127.833057 L22.5376148,87.872911 C33.4679335,76.0285391 50.0301842,70.2733093 72.2710632,70.2733093 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Front left window -->
              <path
                *ngIf="
                  'sideWindow-precision_conductorGlass-frontConductor_left' as id
                "
                [id]="id"
                d="M19.2257112,110.996193 C19.3514598,111.084776 19.4776441,111.200721 19.6059502,111.337279 C20.0133287,111.770858 20.4195804,112.420407 20.8269832,113.270369 C21.6707946,115.030808 22.4979888,117.621438 23.2597239,120.969911 C24.6588646,127.120322 25.8276306,135.804046 26.4342189,146.596882 C27.1574581,159.46525 27.2747231,167.483876 26.7707076,170.650631 C26.6785566,170.844553 26.6212237,170.95313 26.5201668,170.976553 C26.4418342,170.99471 26.3565749,170.982984 26.2829667,170.93708 L26.2829667,170.93708 L19.3736358,166.627971 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Front right window -->
              <path
                *ngIf="
                  'sideWindow-precision_conductorGlass-frontConductor_right' as id
                "
                [id]="id"
                d="M117.356994,110.996193 C117.482743,111.084776 117.608927,111.200721 117.737233,111.337279 C118.144612,111.770858 118.550863,112.420407 118.958266,113.270369 C119.802077,115.030808 120.629272,117.621438 121.391007,120.969911 C122.790147,127.120322 123.958913,135.804046 124.565502,146.596882 C124.980475,153.980371 125.195954,159.767265 125.209047,163.957161 L125.209309,164.659785 C125.20242,167.407703 125.100292,169.404695 124.90199,170.650631 C124.809839,170.844553 124.752507,170.95313 124.65145,170.976553 C124.573117,170.99471 124.487858,170.982984 124.41425,170.93708 L124.41425,170.93708 L117.504919,166.627971 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                transform="translate(121.282020, 141.127243) scale(-1, 1) translate(-121.282020, -141.127243) "
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Rear left window -->
              <path
                *ngIf="
                  'sideWindow-precision_anotherGlass-frontConductor_left' as id
                "
                [id]="id"
                d="M19.3436139,174.441288 L24.6997974,176.715895 L25.1787841,218.89874 C25.1787841,219.007034 25.1230145,219.107693 25.0312002,219.165118 L25.0312002,219.165118 L20.8190883,221.799548 C20.7455301,221.845555 20.6602879,221.85739 20.5819337,221.839335 C20.5384314,221.82931 20.4970523,221.810072 20.4609747,221.782352 L20.4609747,221.782352 L19.25674,174.665516 C19.2547386,174.578778 19.2880839,174.499441 19.3436139,174.441288 L19.3436139,174.441288 Z"
                id="Vitre_AG"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Rear right window -->
              <path
                *ngIf="
                  'sideWindow-precision_anotherGlass-frontConductor_right' as id
                "
                [id]="id"
                d="M119.360023,174.441288 L124.716206,176.715895 L125.195193,218.89874 C125.195193,219.007034 125.139423,219.107693 125.047609,219.165118 L125.047609,219.165118 L120.835497,221.799548 C120.761939,221.845555 120.676697,221.85739 120.598343,221.839335 C120.55484,221.82931 120.513461,221.810072 120.477384,221.782352 L120.477384,221.782352 L119.273149,174.665516 C119.271147,174.578778 119.304493,174.499441 119.360023,174.441288 L119.360023,174.441288 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                transform="translate(122.218657, 198.175443) scale(-1, 1) translate(-122.218657, -198.175443) "
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Rear left custode -->
              <path
                *ngIf="
                  'sideWindow-precision_custodeGlass-frontConductor_left' as id
                "
                [id]="id"
                d="M23.0138999,225.553802 L22.0582033,234.872758 L20.6186964,227.048932 L23.0138999,225.553802 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Rear right custode -->
              <path
                *ngIf="
                  'sideWindow-precision_custodeGlass-frontConductor_right' as id
                "
                [id]="id"
                d="M123.180229,225.578738 L122.224532,234.897694 L120.785025,227.073868 L123.180229,225.578738 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                transform="translate(122.180699, 232.228382) scale(-1, 1) translate(-122.180699, -232.228382) "
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Rear left light -->
              <path
                *ngIf="'lights-lightsEmplacement_rear-lateral_left' as id"
                [id]="id"
                d="M25.425,294.163 L25.5803012,294.303151 C27.6860499,296.176473 30.7350227,298.15074 34.9036221,300.140068 C39.84428,302.497836 43.8288916,303.727897 46.8526981,303.855536 L46.8526981,303.855536 L46.8527207,308.290615 C37.5218017,307.032111 30.4018445,303.316527 25.5101532,297.115852 L25.5101532,297.115852 L25.425,294.163 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Rear right light -->
              <path
                *ngIf="'lights-lightsEmplacement_rear-lateral_right' as id"
                [id]="id"
                d="M97.583,294.162 L97.7387365,294.303151 C99.8444852,296.176473 102.893458,298.15074 107.062057,300.140068 C112.002715,302.497836 115.987327,303.727897 119.011133,303.855536 L119.011133,303.855536 L119.011156,308.290615 C109.680237,307.032111 102.56028,303.316527 97.6685885,297.115852 L97.6685885,297.115852 L97.583,294.162 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                transform="translate(108.287163, 300.644990) scale(-1, 1) translate(-108.287163, -300.644990) "
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Car hood -->
              <path
                d="M72.7423447,4.08443973 C87.8620707,4.08443973 99.8010029,6.12536217 108.551973,10.2332611 C117.188869,14.2876107 122.69518,20.3607936 125.04517,28.4735901 L125.04517,28.4735901 L126.069887,77.8992537 C126.079593,78.3974971 125.886427,78.8525062 125.566273,79.185381 C125.246121,79.5182554 124.798981,79.7289959 124.300738,79.7387025 C123.879815,79.7469029 123.469271,79.6076798 123.140164,79.3451306 C112.871452,71.1531344 96.0844953,67.0172983 72.7423447,67.0172983 C49.4001822,67.0172983 32.6132201,71.1531386 22.3445159,79.3451379 C21.9549514,79.6559093 21.4763013,79.7793617 21.0173483,79.7277307 C20.5583988,79.6761002 20.1191459,79.4493887 19.8083712,79.0598314 C19.5458237,78.7307271 19.4066016,78.320186 19.4148018,77.8992661 L19.4148018,77.8992661 L20.3686062,28.9405411 C22.7895066,20.3607972 28.2958173,14.2876129 36.9327132,10.2332624 C45.6836839,6.12536261 57.6226171,4.08443973 72.7423447,4.08443973 Z"
                id="capot"
                stroke="var(--color-grey-light)"
                stroke-width="2"
                fill="var(--color-grey-extra-light)"
                transform="translate(72.742345, 43.541821) scale(-1, 1) translate(-72.742345, -43.541821) "
              ></path>

              <!-- Left door separation -->
              <path
                d="M19.2495164,168.332008 L26.4680851,172.972516 L26.4680851,175.341115 L19.2495164,172.247443 L19.2495164,168.332008 Z"
                id="Cache"
                stroke="var(--color-grey-light)"
                stroke-width="2"
                fill="var(--color-grey-extra-light)"
              ></path>

              <!-- Right door separation -->
              <path
                d="M117.903288,168.332008 L125.121857,172.972516 L125.121857,175.341115 L117.903288,172.247443 L117.903288,168.332008 Z"
                id="Cache"
                stroke="var(--color-grey-light)"
                stroke-width="2"
                fill="var(--color-grey-extra-light)"
                transform="translate(121.512573, 171.741779) scale(-1, 1) translate(-121.512573, -171.741779) "
              ></path>

              <!-- Left mirror -->
              <path
                *ngIf="'mirror-mirror_left' as id"
                [id]="id"
                d="M18.7256629,94.1220618 L20.594653,108.549485 C19.4799544,107.496168 18.2086767,107.121371 16.7878152,107.401019 C16.2505325,107.506764 15.8078582,107.724964 15.4544847,108.045533 C15.1042661,108.36324 14.8391422,108.784485 14.6697689,109.316452 C14.3973846,110.171956 14.3770815,111.342841 14.6396372,112.832983 L14.6396372,112.832983 L0.63467386,119.622277 C0.213576034,117.348318 0.990560319,114.705664 2.66841742,112.324503 C4.42604185,109.830138 7.18123522,107.617466 10.6664058,106.375378 C13.21053,105.468672 15.1532277,103.968525 16.5012313,101.883198 C17.8098113,99.8588572 18.5577216,97.2741394 18.7256629,94.1220618 L18.7256629,94.1220618 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Right mirror -->
              <path
                *ngIf="'mirror-mirror_right' as id"
                [id]="id"
                d="M141.738035,94.1220618 L143.607025,108.549485 C142.492327,107.496168 141.221049,107.121371 139.800187,107.401019 C139.262905,107.506764 138.82023,107.724964 138.466857,108.045533 C138.116638,108.36324 137.851514,108.784485 137.682141,109.316452 C137.409757,110.171956 137.389454,111.342841 137.652009,112.832983 L137.652009,112.832983 L123.647046,119.622277 C123.225948,117.348318 124.002933,114.705664 125.68079,112.324503 C127.438414,109.830138 130.193607,107.617466 133.678778,106.375378 C136.222902,105.468672 138.1656,103.968525 139.513603,101.883198 C140.822184,99.8588572 141.570094,97.2741394 141.738035,94.1220618 L141.738035,94.1220618 Z"
                id="Retro"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                transform="translate(133.672520, 106.959149) scale(-1, 1) translate(-133.672520, -106.959149) "
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Front left light -->
              <path
                *ngIf="'lights-lightsEmplacement_front-lateral_left' as id"
                [id]="id"
                d="M28.1276953,4.75056441 C30.3852208,6.44292731 33.3319686,8.3411303 37.3502712,10.2570871 C42.1521833,12.5466748 46.0265772,13.7424356 48.9688108,13.8699662 L48.9688108,13.8699662 L48.9688108,18.1511235 C39.8382221,16.9175371 32.885299,13.265986 28.1276953,7.16792317 L28.1276953,7.16792317 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                transform="translate(38.548253, 10.734745) scale(1, -1) translate(-38.548253, -10.734745) "
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Front right light -->
              <path
                *ngIf="'lights-lightsEmplacement_front-lateral_right' as id"
                [id]="id"
                d="M95.4685863,4.75056441 C97.7261119,6.44292731 100.67286,8.3411303 104.691162,10.2570871 C109.493074,12.5466748 113.367468,13.7424356 116.309702,13.8699662 L116.309702,13.8699662 L116.309702,18.1511235 C107.179113,16.9175371 100.22619,13.265986 95.4685863,7.16792317 L95.4685863,7.16792317 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                transform="translate(105.889144, 10.734745) scale(-1, -1) translate(-105.889144, -10.734745) "
                [class.selectedGlass]="isSelected(id)"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </span>

    <!-- Lateral car img  width="407px"
        height="145px"-->
    <span *ngIf="isSidePerspective()">
      <svg
        aria-hidden="true"
        focusable="false"
        viewBox="0 0 407 145"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        style="transform: scaleX(-1);"
      >
        <g
          id="Design-System"
          stroke="none"
          stroke-width="2"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="DS_Icon" transform="translate(-469.000000, -629.000000)">
            <g id="Group-6" transform="translate(469.000000, 629.000000)">
              <g
                id="Group-20-Copy"
                transform="translate(203.500000, 72.500000) scale(-1, 1) translate(-203.500000, -72.500000) "
              >
                <!-- Rear wheel -->
                <circle
                  id="Oval"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                  cx="77.4730777"
                  cy="112.745373"
                  r="31.493121"
                ></circle>

                <!-- Front wheel -->
                <circle
                  id="Oval-Copy-3"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                  cx="338.23612"
                  cy="112.745373"
                  r="31.493121"
                ></circle>

                <!-- Car body -->
                <path
                  d="M119.899556,2.91968692 C139.553973,1.34597812 205.806676,-1.68046983 230.114808,5.75078037 C246.315511,10.7035047 267.449061,21.5302299 293.521064,38.2174317 C299.847614,41.9256183 306.955443,43.0212622 314.871271,41.4986384 C324.621053,42.5002959 387.751278,51.9509446 393.46297,62.5936267 C394.064677,63.7147957 394.683765,64.8237753 395.30909,65.9308334 L395.30909,65.9308334 L396.011559,67.170621 C401.176611,76.2691903 406.319656,85.2833816 405.19026,99.5674921 C404.257761,107.062148 403.545194,111.393308 403.00874,112.542852 L403.00874,112.542852 L405.105903,115.420195 L404.230234,118.267589 L377.306381,121.610044 C377.497404,105.901669 374.349186,94.1072494 367.932824,86.1958595 C361.37857,78.1144488 351.408548,74.0370641 337.982227,74.0370641 C324.544094,74.0370641 314.692953,78.3115517 308.384286,86.7837004 C302.205032,95.0820556 299.42431,107.462636 300.116657,123.955153 L300.116657,123.955153 L116.363327,121.706241 C116.341534,108.266082 113.330232,97.8861606 107.385144,90.5428595 C101.323569,83.0556744 92.2043512,78.6966661 79.9963631,77.5173584 C67.7679352,76.3360763 58.1865616,79.101966 51.2244168,85.7469895 C44.4074288,92.253468 40.0910084,102.516998 38.3361226,116.57384 L38.3361226,116.57384 L10.2514049,112.165386 C7.80835436,112.062271 5.89892723,111.148951 4.53777174,109.398625 C3.12842906,107.586334 2.3023177,104.917612 2.01284572,101.41407 C1.88820024,99.9054584 1.7162644,98.447762 1.5361568,97.0206756 L1.5361568,97.0206756 L1.44617819,96.3140238 C1.42467845,96.1463042 1.40315911,95.9789802 1.38168641,95.8120189 C1.33515114,95.4501834 1.28880249,95.0900725 1.24334369,94.7313389 L1.15382094,94.015605 C0.216012532,86.3985023 -0.1034435,79.3028087 7.02326809,69.3559475 C6.29728149,59.5040273 7.20242621,51.5316953 9.88211337,45.0010154 L9.88211337,45.0010154 L8.64628745,38.8399809 L10.5467473,36.1494876 L44.0848138,33.2672942 C54.5394365,29.3063609 61.9071388,26.0238018 66.1919036,23.427113 C72.5357642,19.5825537 100.302586,4.48879604 119.899556,2.91968692 Z"
                  id="Path-7"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                ></path>

                <!-- Doors -->
                <path
                  d="M122.047658,3.33371265 C162.628382,0.225715184 183.066714,-0.175747038 202.018873,1.29078251 L202.018873,1.29078251 L203.371306,1.39877589 C206.520229,1.65795844 209.640229,1.96846515 212.826414,2.32726204 C243.806477,5.24231185 290.836492,34.8471316 294.160501,39.8416528 C299.84683,62.0378955 298.859521,87.1508353 291.202132,115.177455 C193.864846,114.883602 143.125182,114.405708 138.984819,113.733011 C134.861958,113.063159 121.210927,98.2861403 97.9786486,69.6427616 C91.2466498,46.1757952 88.529882,32.277037 89.9671467,27.9801623 C101.890657,12.1659648 112.329381,6.92486681 122.047658,3.33371265 Z"
                  id="Path-8"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                ></path>

                <!-- Front light -->
                <path
                  *ngIf="'lights-lightsEmplacement_front-lateral_right' as id"
                  [id]="id"
                  d="M372.582334,60.4782577 C380.301081,61.1606452 386.317092,62.7462702 390.282811,64.0536472 L390.282811,64.0536472 L390.802297,64.2272083 C393.584831,65.1694826 395.226239,65.918614 395.500204,66.1322569 C395.910226,66.4520003 397.462391,69.4038603 400.219868,74.911612 L400.219868,74.911612 L400.768094,76.0096744 L400.768094,76.0096744 L400.943408,76.3620707 C400.958988,76.7563827 400.538028,77.7690391 399.796923,79.3879821 C395.416398,78.2920839 388.831256,74.3175323 383.203892,70.192707 C379.637662,67.5786809 376.455544,64.8990875 374.461477,62.8324282 C373.55126,61.8890762 372.892443,61.0837626 372.582334,60.4782577 Z"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  [class.selectedGlass]="isSelected(id)"
                ></path>

                <!-- Rear light -->
                <path
                  *ngIf="'lights-lightsEmplacement_rear-lateral_right' as id"
                  [id]="id"
                  d="M9.60180674,45.4910158 C18.8479935,45.6393238 25.8839568,46.0058701 30.7095402,46.5924967 C33.121844,46.8857507 34.974176,47.2320527 36.2652944,47.636513 C37.2908822,47.9577924 37.995836,48.2562939 38.1383429,48.6892335 C38.2792386,49.1172784 37.9231472,49.7396547 37.3371797,50.5439679 C36.5937763,51.5643815 35.3918262,52.835858 33.7359397,54.3622813 C30.3732553,57.4620589 25.1602909,61.5867619 18.097972,66.73721 C14.8596569,68.1971664 11.0950571,68.9562028 6.80664177,69.0230439 C6.82494567,68.5255656 6.78716488,67.8561553 6.7244597,67.0083466 C6.54366659,64.5639239 6.24306436,60.5111847 7.17186133,54.7655821 C7.48083787,52.8542317 8.29193867,49.7628021 9.60180674,45.4910158 Z"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  [class.selectedGlass]="isSelected(id)"
                ></path>

                <!-- Back door glass -->
                <path
                  *ngIf="
                    'sideWindow-precision_anotherGlass-frontConductor_right' as id
                  "
                  [id]="id"
                  d="M167.811486,7.84017653 C170.114416,7.84839846 171.644862,7.94598728 172.399036,8.15164647 C173.107078,8.34472576 173.691066,9.2435994 174.266781,10.6583991 C174.93373,12.2974036 175.532216,14.6481069 176.06882,17.7084054 C177.13796,23.805808 177.950637,32.6871835 178.509444,44.3521929 L178.509444,44.3521929 L123.284092,41.0137032 L121.780736,10.774424 C144.394828,8.84478147 159.536133,7.86610207 167.202883,7.84018002 L167.202883,7.84018002 Z"
                  id="Path-11"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  [class.selectedGlass]="isSelected(id)"
                ></path>

                <!-- Back custode -->
                <path
                  *ngIf="
                    'sideWindow-precision_custodeGlass-frontConductor_right' as id
                  "
                  [id]="id"
                  d="M117.16859,12.9538622 L117.883578,39.8609546 C110.060368,39.2797823 105.782858,38.9903685 105.051063,38.9903685 C104.700529,38.9903685 103.829726,38.1505536 102.908722,37.0342937 C102.119296,36.0775059 101.306757,34.845741 100.715109,33.457192 C99.8988318,31.5414563 99.4978653,29.3201571 100.20888,27.1184173 C101.490931,23.1484016 107.193415,18.4541771 117.16859,12.9538622 L117.16859,12.9538622 Z"
                  id="Path-12"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  [class.selectedGlass]="isSelected(id)"
                ></path>

                <!-- Conductor glass -->
                <path
                  *ngIf="
                    'sideWindow-precision_conductorGlass-frontConductor_right' as id
                  "
                  [id]="id"
                  d="M193.379266,9.32804541 C215.79824,6.01425862 241.273966,14.2940575 269.817465,34.0899491 L269.817465,34.0899491 L270.553836,49.1118289 L200.32776,44.4173179 Z"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  [class.selectedGlass]="isSelected(id)"
                ></path>

                <!-- Conductor custode -->
                <path
                  *ngIf="
                    'sideWindow-precision_custodeFrontGlass-frontConductor_right' as id
                  "
                  [id]="id"
                  d="M275.12997,36.837068 L285.449752,43.3309567 C286.3189,44.6214996 286.780992,45.7109584 286.780992,46.6113567 C286.780992,47.000469 286.688245,47.3472329 286.494919,47.6492523 C286.290905,47.9679676 285.980175,48.2346129 285.57334,48.4599181 C283.702168,49.4961731 280.21142,49.7168044 275.12997,49.2057949 L275.12997,49.2057949 L275.12997,36.837068 Z"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  [class.selectedGlass]="isSelected(id)"
                ></path>

                <!-- Mirror circle -->
                <circle
                  *ngIf="'mirror-mirror_right' as id"
                  [id]="id"
                  cx="290"
                  cy="40"
                  r="12"
                  fill="transparent"
                  fill-opacity="0.5"
                  [class.selectedGlass]="isSelected(id)"
                />

                <!-- Mirror glass -->
                <!-- <path
                  *ngIf="'mirror-mirror_right' as id"
                  [id]="id"
                  d="M275.217859,35.5918836 C278.344567,36.5538772 280.59709,38.0339201 281.94768,40.0655011 C283.262423,42.0431611 283.71053,44.5313961 283.329285,47.5196645 C278.646503,49.0395969 275.784331,49.681482 274.824084,49.2081734 C274.03819,48.8208036 273.221875,47.3320664 272.594783,44.8136085 C272.070608,42.7084713 271.70952,39.885144 271.68165,36.2940142 L271.68165,36.2940142 Z"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  [class.selectedGlass]="isSelected(id)"
                ></path> -->

                <!-- Door separation -->
                <path
                  d="M184.123113,0.937963871 C195.699396,48.9603454 200.534835,86.8317212 198.612329,114.552739 L198.612329,114.552739 L195.204947,114.552738 C196.110229,95.2231173 195.493744,76.2899823 193.355795,57.7533227 C191.223022,39.2615411 187.392558,20.3230448 181.863745,0.937963208 L181.863745,0.937963208 Z"
                  id="Path-16"
                  stroke="var(--color-grey-light)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                ></path>

                <!-- Back door handle -->
                <path
                  d="M107.89174,59.5657191 C114.045635,57.4513995 119.60814,58.3970643 124.576509,62.4149523 C125.063199,63.0559826 125.331493,63.713016 125.360237,64.3931521 C125.389193,65.0783335 125.176298,65.7781307 124.744774,66.4979434 C122.741059,68.3139537 118.610889,68.5435237 112.489428,67.4391986 C111.154185,66.9411318 110.109443,66.0223274 109.347337,64.6923841 C108.591169,63.3728009 108.111184,61.662055 107.89174,59.5657191 Z"
                  id="Path-17"
                  stroke="var(--color-grey-light)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                ></path>

                <!-- Front door handle -->
                <path
                  d="M202.881343,63.0208925 C209.035239,60.9065729 214.597744,61.8522377 219.566113,65.8701257 C220.052802,66.511156 220.321097,67.1681894 220.34984,67.8483255 C220.378797,68.5335069 220.165902,69.2333041 219.734377,69.9531168 C217.730662,71.7691271 213.600492,71.9986971 207.479031,70.894372 C206.143789,70.3963052 205.099046,69.4775008 204.336941,68.1475575 C203.580772,66.8279743 203.100787,65.1172284 202.881343,63.0208925 Z"
                  id="Path-17-Copy"
                  stroke="var(--color-grey-light)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>

    <!-- Front image  width="216px"
        height="145px"-->
    <span *ngIf="isFrontPerspective()">
      <svg
        aria-hidden="true"
        focusable="false"
        viewBox="0 0 216 145"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        class="front"
      >
        <g
          id="Design-System"
          stroke="none"
          stroke-width="2"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="DS_Icon" transform="translate(-128.000000, -891.000000)">
            <g
              id="Car_avant-Copy"
              transform="translate(128.000000, 891.000000)"
            >
              <g id="Group-25" transform="translate(5.690414, 0.017849)">
                <!-- Right wheel -->
                <path
                  d="M33.2776851,86.8822024 L33.2776851,135.915236 C33.2776851,137.577353 32.7810354,139.201558 31.8514665,140.579431 C31.0036839,141.836076 29.5868881,142.589317 28.0710088,142.589317 L28.0710088,142.589317 L8.3299879,142.589317 C7.64527359,142.589317 6.98835264,142.40087 6.42184968,142.061494 C5.85534672,141.722118 5.37926173,141.231811 5.05621934,140.628092 C4.30724602,139.228369 3.91537243,137.665406 3.91537243,136.077897 L3.91537243,136.077897 L3.91537243,86.8822024 L33.2776851,86.8822024 Z"
                  id="Path-19"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                ></path>

                <!-- Left wheel -->
                <path
                  d="M200.495824,86.8822024 L200.495824,135.915236 C200.495824,137.577353 199.999175,139.201558 199.069606,140.579431 C198.221823,141.836076 196.805027,142.589317 195.289148,142.589317 L195.289148,142.589317 L175.548127,142.589317 C174.863413,142.589317 174.206492,142.40087 173.639989,142.061494 C173.073486,141.722118 172.597401,141.231811 172.274358,140.628092 C171.525385,139.228369 171.133512,137.665406 171.133512,136.077897 L171.133512,136.077897 L171.133512,86.8822024 L200.495824,86.8822024 Z"
                  id="Path-19-Copy"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                ></path>

                <!-- Under license plate (hidden) -->
                <rect
                  id="Rectangle"
                  stroke="var(--color-grey-dark)"
                  stroke-width="2"
                  fill="#D8D8D8"
                  x="69.7680654"
                  y="106.701524"
                  width="65.0051111"
                  height="11.0684681"
                  rx="1.5747925"
                ></rect>

                <!-- Car body -->
                <path
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                  d="M101.961561,0.794087709 C122.630383,0.794087709 143.29861,1.8119844 163.966394,3.84937588 C173.533063,18.3373025 179.562641,28.0901767 182.050827,33.1102932 C184.613362,38.2804143 185.870071,41.7331609 185.73828,43.4778842 L185.73828,43.4778842 L203.229583,60.1388089 C201.040162,79.2473405 199.165229,93.5890872 197.604324,103.163982 C196.106993,112.348902 194.655693,118.671648 193.231516,122.126611 C162.641407,119.99087 132.218089,118.923009 101.961561,118.923009 C71.7047915,118.923009 41.4483249,119.990887 11.194471,122.125874 C9.51493324,118.068719 7.90433003,111.498117 6.35104316,102.418096 C4.74269848,93.0162251 2.85691754,78.9212737 0.693090377,60.1333348 L0.693090377,60.1333348 L17.6140571,43.5676735 C18.8697058,40.1656477 20.0845739,36.7478255 21.2586613,33.3142069 C22.3125758,30.2320337 27.522593,21.6813737 36.867278,7.65572937 L37.5758815,6.59354035 C38.1728443,5.699828 38.7859561,4.78472836 39.4152116,3.84823984 C60.4421666,1.8121597 81.2909487,0.794087709 101.961561,0.794087709 Z"
                ></path>

                <!-- Windshield -->
                <path
                  *ngIf="'windshield' as id"
                  [id]="id"
                  d="M160.689512,7.64200532 C161.098871,7.64200714 161.491807,7.75405637 161.831201,7.95606154 C162.170595,8.15806618 162.456447,8.45002632 162.651641,8.80985064 C165.612553,14.2680513 167.690972,19.712512 168.884712,25.1440282 C169.99766,30.2079456 170.346484,35.2835218 169.930808,40.3707846 C169.883482,40.9500284 169.617864,41.4626424 169.218783,41.8304456 C168.819702,42.1982498 168.287158,42.4212424 167.705982,42.4212424 L167.705982,42.4212424 L36.8317415,42.4212424 C36.2509886,42.4212359 35.7187585,42.1985527 35.3197517,41.8311765 C34.9207469,41.4638023 34.6549643,40.9517364 34.607104,40.3729619 C34.1882928,35.3082778 34.5382994,30.2319795 35.6565304,25.1440282 C36.8563043,19.6850574 38.9342787,14.239886 41.8884344,8.80778089 C42.0838089,8.44853237 42.3695938,8.15708805 42.7087698,7.95545603 C43.0479443,7.7538249 43.4405094,7.64200532 43.8494461,7.64200532 L43.8494461,7.64200532 Z"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  mask="url(#mask-2)"
                  [class.selectedGlass]="isSelected(id)"
                ></path>

                <!-- Right minor light -->
                <path
                  d="M41.1416605,105.568518 C49.2807232,105.830593 55.4078781,108.220081 59.6104769,112.718622 C59.4940793,112.970906 59.3123281,113.169563 59.0631164,113.312962 C58.6749522,113.536316 58.1482531,113.633913 57.4921027,113.633913 C55.9677235,113.633913 51.0304765,112.797978 42.6814385,111.140192 C42.1089266,110.905685 41.6747029,110.677357 41.3843793,110.446363 C41.2301209,110.323628 41.090793,110.216355 41.090793,110.081429 L41.090793,110.081429 L41.090793,105.866263 C41.0998623,105.731988 41.1012863,105.625398 41.1416605,105.568518 Z"
                  id="Path-21-Copy-2"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  mask="url(#mask-2)"
                  transform="translate(50.387701, 109.568516) rotate(-10.000000) translate(-50.387701, -109.568516) "
                ></path>

                <!-- Car hood contour -->
                <path
                  d="M186.922744,46.7397117 C183.580287,49.8036537 181.389486,54.7212858 180.397673,61.5266888 C180.369522,61.7198485 180.342731,61.9118263 180.317872,62.1019124 C180.508205,62.0998349 180.69973,62.0987966 180.892446,62.0987966 C188.865834,62.0987966 194.800119,63.8761466 198.664499,67.4922727 L198.664499,67.4922727 L198.664499,79.0990448 C194.892632,83.2600079 189.882126,85.3305796 183.642432,85.3305796 C177.150588,85.3305796 166.172871,88.4592335 150.712962,94.7506991 L150.712962,94.7506991 L51.510179,94.7506991 C34.3191774,88.4555906 24.1304178,85.3305796 20.9462166,85.3305796 C17.8459428,85.3305796 12.8082322,83.351776 5.8245106,79.4540355 C4.12178969,74.2451815 4.08186456,70.265716 5.83141721,67.5481122 C7.41597831,65.086792 13.6892299,64.3276752 18.438786,63.6692396 C20.3731039,63.4010832 22.0829807,63.1622367 23.2008561,62.8711375 C23.6935681,62.7428334 24.0804615,62.5999513 24.3409635,62.447153 C24.7777529,62.1909527 24.9191114,61.8855668 24.9191114,61.5987966 C24.9191114,60.4055047 22.4377541,55.4504618 17.3612254,46.7397117 L17.3612254,46.7397117 Z"
                  id="Path-23"
                  stroke="var(--color-grey-light)"
                  fill="var(--color-grey-extra-light)"
                  mask="url(#mask-2)"
                ></path>

                <!-- Left minor light -->
                <path
                  d="M134.941715,105.568518 C143.080778,105.830593 149.207933,108.220081 153.410531,112.718622 C153.294134,112.970906 153.112383,113.169563 152.863171,113.312962 C152.475007,113.536316 151.948308,113.633913 151.292157,113.633913 C149.767778,113.633913 144.830531,112.797978 136.481493,111.140192 C135.908981,110.905685 135.474757,110.677357 135.184434,110.446363 C135.030175,110.323628 134.890847,110.216355 134.890847,110.081429 L134.890847,110.081429 L134.890847,105.866263 C134.899917,105.731988 134.901341,105.625398 134.941715,105.568518 Z"
                  id="Path-21-Copy-3"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  mask="url(#mask-2)"
                  transform="translate(144.187755, 109.568516) scale(-1, 1) rotate(-10.000000) translate(-144.187755, -109.568516) "
                ></path>

                <!-- Right light -->
                <path
                  *ngIf="'lights-lightsEmplacement_front-lateral_right' as id"
                  [id]="id"
                  d="M15.5758242,65.6551334 C34.4939788,66.4015086 48.8665131,72.1060801 58.6686573,82.8148687 C58.3657825,83.739309 57.7972114,84.4446445 56.9590978,84.9278991 C55.9824855,85.4910116 54.6619013,85.7584566 53.0064634,85.7584566 C49.4829528,85.7584566 38.0613465,83.8293112 18.7442466,79.9851496 C17.3214547,79.4048392 16.2492458,78.833996 15.5335124,78.2633518 C14.9530148,77.8005292 14.6008983,77.3561098 14.6008983,76.887218 L14.6008983,76.887218 L14.6008983,67.1489492 C14.6377324,66.6518127 14.7015146,66.2906142 14.8438324,66.0897014 C14.9686072,65.9135544 15.224105,65.7817566 15.5758242,65.6551334 Z"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  mask="url(#mask-2)"
                  [class.selectedGlass]="isSelected(id)"
                ></path>

                <!-- Left light -->
                <path
                  *ngIf="'lights-lightsEmplacement_front-lateral_left' as id"
                  [id]="id"
                  d="M145.698043,65.5191657 C164.616198,66.2655409 178.988732,71.9701124 188.790876,82.678901 C188.488002,83.6033413 187.91943,84.3086768 187.081317,84.7919314 C186.104705,85.3550439 184.78412,85.6224889 183.128682,85.6224889 C179.605172,85.6224889 168.183566,83.6933434 148.866466,79.8491819 C147.443674,79.2688715 146.371465,78.6980283 145.655731,78.1273841 C145.075234,77.6645615 144.723117,77.2201421 144.723117,76.7512503 L144.723117,76.7512503 L144.723117,67.0129815 C144.759951,66.515845 144.823734,66.1546465 144.966051,65.9537337 C145.090826,65.7775867 145.346324,65.6457889 145.698043,65.5191657 Z"
                  stroke="var(--color-grey-main)"
                  stroke-width="2"
                  fill="white"
                  mask="url(#mask-2)"
                  transform="translate(166.787797, 75.569059) scale(-1, 1) translate(-166.787797, -75.569059) "
                  [class.selectedGlass]="isSelected(id)"
                ></path>

                <!-- Car hood -->
                <path
                  d="M172.937135,46.4914986 C172.985095,46.4874805 173.030143,46.5032823 173.064206,46.5320785 C173.129132,46.6956027 173.115304,46.7402883 173.086791,46.7752768 C163.357264,58.7143534 155.993617,66.8522572 150.988018,71.1808329 C137.193049,83.109988 123.267197,89.0700615 101.961561,89.0700615 C80.6561142,89.0700615 66.4490395,83.1104395 52.0851714,71.1883665 C46.959434,66.9339822 39.3826078,58.9998119 29.348229,47.393659 L29.348229,47.393659 L28.8249403,46.7877178 C28.7935049,46.7512688 28.7798194,46.7055286 28.783105,46.6610419 C28.7863906,46.6165552 28.8066474,46.5733219 28.8430964,46.5418865 C28.8785492,46.5113104 28.9248117,46.4962815 28.9714654,46.5001846 C52.9485023,48.5061123 76.9255394,49.5090705 100.902576,49.5090705 C123.870125,49.5090705 146.837673,48.588788 169.806901,46.7480773 L169.806901,46.7480773 Z"
                  id="Path-22"
                  stroke="var(--color-grey-light)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                  mask="url(#mask-2)"
                ></path>

                <!-- License plate -->
                <path
                  d="M102.270621,87.2437452 C113.357457,87.2437452 124.436402,88.3857737 135.50751,90.6694627 C135.763377,90.7222369 135.983093,90.8612719 136.138843,91.0524263 C136.294596,91.2435844 136.386381,91.4868634 136.386381,91.7481209 L136.386381,91.7481209 L136.386381,104.428787 C136.386381,104.732922 136.263106,105.008264 136.063797,105.207573 C135.864488,105.406882 135.589145,105.530157 135.28501,105.530157 L135.28501,105.530157 L68.8356564,105.530157 C68.5315214,105.530157 68.2561787,105.406882 68.0568699,105.207573 C67.857561,105.008264 67.7342859,104.732922 67.7342859,104.428787 L67.7342859,104.428787 L67.7342859,91.7557747 C67.7342838,91.4936369 67.8266743,91.2496668 67.9833043,91.0582663 C68.1399358,90.866864 68.3608077,90.728032 68.6177668,90.6761719 C79.9546221,88.3881392 91.1722156,87.2437452 102.270621,87.2437452 Z"
                  id="Rectangle"
                  stroke="var(--color-grey-light)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                  mask="url(#mask-2)"
                ></path>

                <!-- License plate -->
                <path
                  d="M102.270621,87.2437452 C113.357457,87.2437452 124.436402,88.3857737 135.50751,90.6694627 C135.763377,90.7222369 135.983093,90.8612719 136.138843,91.0524263 C136.294596,91.2435844 136.386381,91.4868634 136.386381,91.7481209 L136.386381,91.7481209 L136.386381,104.428787 C136.386381,104.732922 136.263106,105.008264 136.063797,105.207573 C135.864488,105.406882 135.589145,105.530157 135.28501,105.530157 L135.28501,105.530157 L68.8356564,105.530157 C68.5315214,105.530157 68.2561787,105.406882 68.0568699,105.207573 C67.857561,105.008264 67.7342859,104.732922 67.7342859,104.428787 L67.7342859,104.428787 L67.7342859,91.7557747 C67.7342838,91.4936369 67.8266743,91.2496668 67.9833043,91.0582663 C68.1399358,90.866864 68.3608077,90.728032 68.6177668,90.6761719 C79.9546221,88.3881392 91.1722156,87.2437452 102.270621,87.2437452 Z"
                  id="Rectangle"
                  stroke="var(--color-grey-light)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                  mask="url(#mask-2)"
                ></path>

                <!-- License plate -->
                <path
                  d="M102.270621,87.2437452 C113.357457,87.2437452 124.436402,88.3857737 135.50751,90.6694627 C135.763377,90.7222369 135.983093,90.8612719 136.138843,91.0524263 C136.294596,91.2435844 136.386381,91.4868634 136.386381,91.7481209 L136.386381,91.7481209 L136.386381,104.428787 C136.386381,104.732922 136.263106,105.008264 136.063797,105.207573 C135.864488,105.406882 135.589145,105.530157 135.28501,105.530157 L135.28501,105.530157 L68.8356564,105.530157 C68.5315214,105.530157 68.2561787,105.406882 68.0568699,105.207573 C67.857561,105.008264 67.7342859,104.732922 67.7342859,104.428787 L67.7342859,104.428787 L67.7342859,91.7557747 C67.7342838,91.4936369 67.8266743,91.2496668 67.9833043,91.0582663 C68.1399358,90.866864 68.3608077,90.728032 68.6177668,90.6761719 C79.9546221,88.3881392 91.1722156,87.2437452 102.270621,87.2437452 Z"
                  id="Rectangle"
                  stroke="var(--color-grey-light)"
                  stroke-width="2"
                  fill="var(--color-grey-extra-light)"
                  mask="url(#mask-2)"
                ></path>
              </g>

              <!-- Right mirror -->
              <path
                *ngIf="'mirror-mirror_right' as id"
                [id]="id"
                d="M4.91578536,40.2440662 C8.99781868,39.5242996 14.6705226,39.6327051 16.4038935,39.664957 C16.9885379,39.6698237 17.2515901,39.8134524 17.48342,40.150159 C17.7752411,40.5739961 18.0370994,41.2068345 18.2811196,42.0422982 L18.2811196,42.0422982 L18.2811196,46.9386487 L24.2141491,46.9386487 L21.6688534,51.0908412 L4.89978131,51.0908412 C3.52129558,51.0908412 2.19208975,50.1220823 0.863056512,48.3215909 C0.402180781,46.285318 0.411240229,44.2057067 0.888064551,42.0827773 C0.979449877,41.6759092 1.37726625,41.3811431 1.897724,41.1190662 C2.66000408,40.7352196 3.71774404,40.4553115 4.91578536,40.2440662 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                [class.selectedGlass]="isSelected(id)"
              ></path>

              <!-- Left mirror -->
              <path
                *ngIf="'mirror-mirror_left' as id"
                [id]="id"
                d="M194.96288,40.2440662 C199.044913,39.5242996 204.717617,39.6327051 206.450988,39.664957 C207.035632,39.6698237 207.298684,39.8134524 207.530514,40.150159 C207.822335,40.5739961 208.084194,41.2068345 208.328214,42.0422982 L208.328214,42.0422982 L208.328214,46.9386487 L214.261243,46.9386487 L211.715948,51.0908412 L194.946876,51.0908412 C193.56839,51.0908412 192.239184,50.1220823 190.910151,48.3215909 C190.449275,46.285318 190.458334,44.2057067 190.935159,42.0827773 C191.026544,41.6759092 191.42436,41.3811431 191.944818,41.1190662 C192.707098,40.7352196 193.764838,40.4553115 194.96288,40.2440662 Z"
                stroke="var(--color-grey-main)"
                stroke-width="2"
                fill="white"
                transform="translate(202.621767, 45.365495) scale(-1, 1) translate(-202.621767, -45.365495) "
                [class.selectedGlass]="isSelected(id)"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </span>
  `,
  imports: [NgIf],
})
export class CarMiniatureImgComponent {
  @Input() glassExtended: GlassExtended;
  @Input() hideCustodes = false;
  @Input() hideClassicLateral = false;

  otherGlasses: Glass[];

  constructor(
    private readonly carImgService: CarImgService,
    private readonly configurationService: ConfigurationService
  ) {
    this.otherGlasses = this.configurationService.getGlassUsage()?.otherGlasses;
  }

  isTopPerspective() {
    return (
      !this.isFrontPerspective() && !this.isSidePerspective() // Default to top perspective
    );
  }

  isFrontPerspective() {
    return this.glassExtended === 'lights';
  }

  isSidePerspective() {
    return (
      this.glassExtended === 'sideWindow' ||
      this.glassExtended === 'custodes' ||
      this.glassExtended === 'other'
    );
  }

  isSelected(id: string): boolean {
    if (this.glassExtended === 'multiple') {
      return true;
    }
    const glassToTest = this.carImgService.getAnswerById(id);
    return (
      (glassToTest?.glassExtended || glassToTest?.glass) === this.glassExtended
    );
  }
}
